module.exports = __webpack_public_path__ + "img/info.6080b604.png";